<div id="scheduleDetails" *ngIf="schedule" class="schedule-details nova-font-style">
  <div id="print-section1">
    <h2>Schedule Details for {{schedule.payScheduleName}} ({{schedule.fiscalYear}})</h2>
    <h4 class="padding-10">{{orgName}}</h4>
    <div class="keyValuePairs noBorders printTable printTable1" id="scheduleInfo" aria-hidden="true">
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Fiscal Year:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.fiscalYear}} </span></div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Schedule Name:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.payScheduleName}}</span></div>
      </div>
      <!-- HIDE EMPLOYER PAYROLL SCEDULE ID FOR FUTURE USE -->
      <div class="row" *ngIf="hideEmpScheduleSection">
        <div class="col s12 m12 l6 xl3 bold">Employer Payroll Schedule ID(Optional):</div>
        <div class="col s12 m6 l5 xl3 inline-flex-display" *ngIf="!isSchChangesVisible">
          <span class="padding-for-print right-margin-10">{{schedule.employerScheduleID}}</span>
        </div>
        <div class="col s12 m6 l5 xl3 inline-flex-display" *ngIf="isSchChangesVisible">
          <div *ngIf="schedule.fiscalYear >= cfy; else editEmpSchedule">
            <span class="padding-for-print right-margin-10">{{schedule.employerScheduleID}}</span>
          </div>
          <ng-template #editEmpSchedule>
            <span class="padding-for-print right-margin-10"
              *ngIf="isInputVisible">{{schedule.employerScheduleID}}</span>
            <div *ngIf="!isInputVisible" class="right-margin-10">
              <input kendoTextBox class="name-style" placeholder="Schedule ID" id="schedule-id"
                (input)="onEmpIdInput(schedule.employerScheduleID)" [(ngModel)]="schedule.employerScheduleID" />
            </div>
            <button title="Edit" *ngIf="isInputVisible && operators.Edit"
              [disabled]="isProcessing" class="k-button left-margin-5" (click)="editClick()"><span
                class="k-icon k-i-edit link-icon"></span></button>
            <button title="Save" *ngIf="!isInputVisible" [disabled]="isProcessing || schedule.employerScheduleID.length === 0 || schedule.employerScheduleID.length > 10
               || invalidAlphaNumeric || empScheduleIdExists || btnDisable" class="k-button left-margin-5"
              (click)="onSaveClick(schedule, schedule.employerScheduleID)">
              <span *ngIf="!isProcessing" class="k-icon k-icon k-i-save link-icon"></span>
              <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
            </button>
            <button title="Cancel" *ngIf="!isInputVisible" [disabled]="isProcessing" class="k-button left-margin-5"
              (click)="cancelClick()"><span class="k-icon k-i-close link-icon"></span></button>
          </ng-template>
        </div>
      </div>
      <div class="input-validation left-margin-17p">
        <span class="validationError"
          *ngIf="schedule.employerScheduleID.length > 10; else invalidString">{{config.MaxEmpIdLength}}</span>
        <span class="validationError" *ngIf="empScheduleIdExists">{{config.EmpIdExists}}</span>
        <ng-template #invalidString>
          <span class="validationError" *ngIf="invalidAlphaNumeric">{{config.EmpIdAlNum}}</span>
        </ng-template>
      </div>

      <div *ngIf="actionType !== 'ContinuePartial' && actionType !== 'ContinueSchedule'" class="row">
        <div class="col s12 m12 l6 xl3 bold">Payroll Schedule ID:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.id}}</span></div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Location(s):</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.locations}}</span></div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">System(s):</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.systems}}</span> </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Comments:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.comments}}</span> </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Created:</div>
        <div class="col s12 m12 l6 xl6" *ngIf="!schedule.createdDetails">
          <span class="padding-for-print">{{schedule.createdDatetime  | date: 'MM/dd/yyyy'}} by
            {{schedule.createdBy}}</span>
        </div>
        <div class="col s12 m12 l6 xl6" *ngIf="schedule.createdDetails">
          <span class="padding-for-print">{{schedule.createdDetails}}</span>
        </div>
      </div>
      <div *ngIf="schedule.modifiedDetails" class="row">
        <div class="col s12 m12 l6 xl3 bold">Modified: </div>
        <div class="col s12 m12 l6 xl6"> <span class="padding-for-print">{{schedule.modifiedDetails}}</span></div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Frequency:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.frequency}}</span> </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Total Annual Pays:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.payCount}}</span> </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Contributory Pays:</div>
        <div class="col s12 m12 l6 xl6"><span class="padding-for-print">{{schedule.contributoryCount}}</span> </div>
      </div>
      <div class="row">
        <div class="col s12 m12 l6 xl3 bold">Non-Contributory Pays:</div>
        <div class="col s12 m12 l6 xl6">
          <span class="padding-for-print"> {{schedule.payCount - schedule.contributoryCount}}</span>
        </div>
      </div>
      <div *ngIf="schedule.createdFrom" class="row">
        <div class="col s12 m12 l6 xl3 bold" *ngIf="schedule.createdFrom > 0">Created From: </div>
        <div class="col s12 m12 l6 xl6"> <span class="padding-for-print">{{schedule.createdFrom}}</span></div>
      </div>
    </div>
  </div>
  <div class="stroke-separator"></div>
  <div class="topright">
    <span class="k-icon k-i-print"></span>
    <a (click)="print()" [ngClass]=" !isInputVisible ? 'disable-link' : ''" target="_blank" class="clone-link">Printer
      Friendly Version</a>
  </div>
  <div id="print-section2" class="totals-table">
    <h3>Schedule Entries</h3>
    <div class="right-margin-5">
      <table class="printTable2" aria-hidden="true">
        <thead>
          <tr>
            <th scope="col" class="align-id color-white">#</th>
            <th scope="col" class="align-date color-white">PPED </th>
            <th scope="col" class="align-date color-white">Pay Date</th>
            <th scope="col" class="align-center color-white">Contributory</th>
            <th scope="col" class="align-text color-white">Remarks</th>
            <th scope="col" class="align-text color-white" id="misc-td"></th>
          </tr>
        </thead>
        <tbody>
          <tr id="Entries" *ngFor="let item of scheduleEntry; let row_no = index">
            <td class="align-id">
              {{row_no + 1}}
            </td>
            <td class="align-date">{{item.payPeriodEndDate | date: 'MM/dd/yyyy'}}</td>
            <td class="align-date">{{item.payDate | date: 'MM/dd/yyyy'}}</td>
            <!-- inline style for print schedule -->
            <td class="align-center">
              <span *ngIf="item.isContributory" class="k-icon k-i-checkmark text-green"></span>
              <span class="for-print">{{item.isContributory ? 'Yes' : ''}}</span>
            </td>
            <td class="align-text">{{item.remarks}}</td>
            <td class="align-text printhidden">
              <div *ngIf="item.isHolidayOrWeekend">
                <span class="k-icon k-i-warning text-gold"></span>
                <span id="msgHolidayContainer">{{item.holidayOrWeekendName}}</span>
              </div>
            </td>
          </tr>
          <tr *ngIf="!scheduleEntry">
            <td colspan="5" class="align-center">{{noScheduleEntryText}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
